import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('FEATURE_TOGGLZ', {
  GET_FEATURES_REQUEST: null,
  GET_FEATURES_SUCCESS: null,
  GET_FEATURES_FAILURE: null
});
